import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { ENavTransparency, INavigation, INavParams } from '@features/navigation/typescript';
import { TCategoriesTree, TServiceMap } from '@features/categories/typescript';
import NavigationDesktop from '@features/navigation/components/NavigationDesktop/NavigationDesktop';
const NavigationClientDynamic = dynamic(() => import('@features/navigation/components/NavigationClient/NavigationClient'), {
  ssr: false
});
type PropsType = {
  navElements: INavigation;
  serviceMap: TServiceMap;
  navParams: INavParams;
  categoriesTree: TCategoriesTree;
};
const Navigation = ({
  navElements,
  categoriesTree,
  serviceMap,
  navParams
}: PropsType) => {
  const {
    navTransparency,
    backgroundColor,
    fontColorVariant,
    withBorder
  } = navParams;
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const navTransparencyDesktop = navTransparency === ENavTransparency.BOTH_TRANSPARENT || navTransparency === ENavTransparency.DESKTOP_TRANSPARENT_MOBILE_NOT_TRANSPARENT;
  if (!mounted) {
    return <NavigationDesktop navElements={navElements} categoriesTree={categoriesTree} serviceMap={serviceMap} isTransparent={navTransparencyDesktop} backgroundColor={backgroundColor} fontColorVariant={fontColorVariant} withBorder={withBorder} />;
  } else {
    return (
      // @ts-expect-error - React 19 compatibility issue with next/dynamic types
      <NavigationClientDynamic navElements={navElements} categoriesTree={categoriesTree} serviceMap={serviceMap} navParams={navParams} />
    );
  }
};
export default Navigation;